import React from 'react'
import Chip from '@mui/material/Chip'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  status: string | undefined
}

const PortfolioSettlementProjectStatusChip: React.FC<ComponentProps> = ({ status }: ComponentProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (status === 'PENDING') {
    variant = 'outlined'
  } else if (status === 'COAS_UPDATING' || status === 'REFUNDS_PROCESSING') {
    color = 'warning'
    // variant = 'outlined'
  } else if (status === 'COAS_UPDATED' || status === 'REFUNDS_PROCESSED') {
    color = 'success'
    variant = 'outlined'
  } else {
    color = 'warning'
    variant = 'outlined'
  }

  return (
    <>
      {status === undefined
        ? (
          <></>
          )
        : (
          <Tooltip title={status} TransitionComponent={Zoom} arrow placement='bottom'>
            <Chip label={status} variant={variant} color={color} />
          </Tooltip>
          )
      }
    </>
  )
}

export default PortfolioSettlementProjectStatusChip
